import { AccountManagerPhotoComponent } from './components/account-manager-photo/account-manager-photo.component';
import { BlogComponent } from './landing/job/blog/blog.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CandidatesComponent } from './landing/job/candidates/candidates.component';
import { CategoriesComponent } from './landing/nft/categories/categories.component';
import { ClientLogoComponent } from './landing/index/client-logo/client-logo.component';
import { CollectionComponent } from './landing/index/collection/collection.component';
import { CommonModule } from '@angular/common';
import { ContactComponent } from './landing/index/contact/contact.component';
import { CounterComponent } from './landing/index/counter/counter.component';
import { CountUpModule } from 'ngx-countup';
import { CtaComponent } from './landing/index/cta/cta.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CustomiseMessageComponent } from './customise-message/customise-message.component';
import { DesignedComponent } from './landing/index/designed/designed.component';
import { DiscoverComponent } from './landing/nft/discover/discover.component';
import { FaqsComponent } from './landing/index/faqs/faqs.component';
import { FeaturesComponent } from './landing/nft/features/features.component';
import { FindjobsComponent } from './landing/job/findjobs/findjobs.component';
import { FooterComponent } from './landing/index/footer/footer.component';
import { JobcategoriesComponent } from './landing/job/jobcategories/jobcategories.component';
import { JobFooterComponent } from './landing/job/job-footer/job-footer.component';
import { LandingScrollspyDirective } from './landingscrollspy.directive';
import { MarketPlaceComponent } from './landing/nft/market-place/market-place.component';
import { NgbNavModule, NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { PlanComponent } from './landing/index/plan/plan.component';
import { ProcessComponent } from './landing/job/process/process.component';
import { ReviewComponent } from './landing/index/review/review.component';
import { RisklineAttributionComponent } from './riskline-attribution/riskline-attribution.component';
import { ScrollspyDirective } from './scrollspy.directive';
import { ServicesComponent } from './landing/index/services/services.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerOverlayWrapperComponent } from './spinner-overlay-wrapper/spinner-overlay-wrapper.component';
import { TeamComponent } from './landing/index/team/team.component';
import { TopCreatorComponent } from './landing/nft/top-creator/top-creator.component';
import { WalletComponent } from './landing/nft/wallet/wallet.component';
import { WorkProcessComponent } from './landing/index/work-process/work-process.component';

@NgModule({
  declarations: [
    AccountManagerPhotoComponent,
    BlogComponent,
    BreadcrumbsComponent,
    CandidatesComponent,
    CategoriesComponent,
    ClientLogoComponent,
    CollectionComponent,
    ContactComponent,
    CounterComponent,
    CtaComponent,
    CustomiseMessageComponent,
    DesignedComponent,
    DiscoverComponent,
    FaqsComponent,
    FeaturesComponent,
    FindjobsComponent,
    FooterComponent,
    JobcategoriesComponent,
    JobFooterComponent,
    LandingScrollspyDirective,
    MarketPlaceComponent,
    PlanComponent,
    ProcessComponent,
    ReviewComponent,
    RisklineAttributionComponent,
    ScrollspyDirective,
    ServicesComponent,
    SpinnerComponent,
    SpinnerOverlayWrapperComponent,
    TeamComponent,
    TopCreatorComponent,
    WalletComponent,
    WorkProcessComponent
  ],
  imports: [
    CommonModule,
    CountUpModule,
    NgbAccordionModule,
    NgbDropdownModule,
    NgbNavModule,
    SlickCarouselModule,
  ],
  exports: [
    AccountManagerPhotoComponent,
    BlogComponent,
    BreadcrumbsComponent,
    CandidatesComponent,
    CategoriesComponent,
    ClientLogoComponent,
    CollectionComponent,
    ContactComponent,
    CounterComponent,
    CtaComponent,
    CustomiseMessageComponent,
    DesignedComponent,
    DiscoverComponent,
    FaqsComponent,
    FeaturesComponent,
    FindjobsComponent,
    FooterComponent,
    JobcategoriesComponent,
    JobFooterComponent,
    LandingScrollspyDirective,
    MarketPlaceComponent,
    PlanComponent,
    ProcessComponent,
    ReviewComponent,
    RisklineAttributionComponent,
    ScrollspyDirective,
    ServicesComponent,
    SpinnerComponent,
    SpinnerOverlayWrapperComponent,
    TeamComponent,
    TopCreatorComponent,
    WalletComponent,
    WorkProcessComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule { }
